export default class DataTableRow{
  constructor(cells){
    this.cells = cells;
  }

  render(){
    return this.cells.map((cell) => this.#datatableRowFormat(cell));
  }

  csvRow(separator = ';'){
    return this.cells.map((cell) => cell.value).join(separator);
  }

  #datatableRowFormat(cell){
    return {
      content: cell.value,
      format: cell.render(),
      editable: cell.editable
    }
  }
}
